import React from "react";
import { Container, Typography } from "@mui/material";
import EmptyState from "../../Components/EmptyState/EmptyState";

interface PlaceholderPageProps {
  title: string;
  emptyStateText: string;
  emptyStateImage: string;
  actionButtons: React.ReactNode;
}

const PlaceholderPage: React.FC<PlaceholderPageProps> = ({
  title,
  emptyStateText,
  emptyStateImage,
  actionButtons,
}) => {
  const hasData = false; // Replace with actual data check

  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      <Typography variant="h4" gutterBottom>
        {title}
      </Typography>
      {hasData ? (
        <div>
          {" "}
          {/* Replace with table component when data is available */}
          {/* Table Component */}
        </div>
      ) : (
        <EmptyState
          image={emptyStateImage}
          text={emptyStateText}
          actionButtons={actionButtons}
        />
      )}
    </Container>
  );
};

export default PlaceholderPage;
